module.exports = __webpack_public_path__ + "img/pr-1.46dca5cf.png";